import { graphql } from "react-apollo";
import { DELETE_REGION_COMMENT } from "../../graphql/mutations";

export default graphql(DELETE_REGION_COMMENT, { name: "deleteRegionComment" });
